module.exports = __webpack_public_path__ + "img/42.a7c10112.png";